import { useContext } from 'react';
import Radio from '@veeva/corgix/radio';
import PropTypes from 'prop-types';
import { ThemeProvider, useTheme } from 'emotion-theming';
import CustomerStatFilterContext from './CustomerStatFilterContext';
import CustomCustomerStatFilter from './CustomCustomerStatFilter';
import {
    customerStatFilterByCustomerIdDivCSS,
    customerStatFilterRadioCSS,
    customStatFilterRadioCSS,
    statFilterTableHeadingCSS,
    selectedRadioCSS,
} from './styles/CustomerStatFilterSavedFiltersSelection.styles';
import { getRedReportPendingFilterList } from '../../services/getRedReportFilterList';
import pageGroupType from '../PageGroupType';

export default function CustomerStatFilterSavedFiltersSelection({
    allStats,
    mobile,
    familyId,
    showPlatformOnlyFilters,
}) {
    const {
        selectedCustomerFilterList,
        setSelectedCustomerFilterList,
        setPendingFilterId,
        pendingFilterId,
        userPreferenceFilters,
        setUserPreferenceFilters,
        setPendingFilterList,
        setPendingFilterQuery,
        pendingFilterQuery,
        pendingFilterList,
        pendingCreateCustomFilterList,
        pendingCreateCustomFilterQuery,
        setPendingFilterName,
        pendingCreateCustomFilterName,
        setNoEmptyRows,
        pageGroup,
        setErrorMsg,
    } = useContext(CustomerStatFilterContext);

    const handleSetSelectedCustomerList = (newValue) => {
        if (newValue === 'create_custom') {
            setPendingFilterList(pendingCreateCustomFilterList);
            setPendingFilterQuery(pendingCreateCustomFilterQuery);
            setPendingFilterId('');
        } else if (newValue === 'redReport') {
            setPendingFilterList(getRedReportPendingFilterList(allStats));
            setPendingFilterQuery('(1 AND 2) OR (3 AND 4) OR (5 AND 6) OR (7 AND 8)');
            setPendingFilterId('redReport');
        } else {
            const matchFilter = userPreferenceFilters.filter((f) => f.filterName === newValue);
            if (matchFilter.length === 0) {
                setPendingFilterList([]);
                setPendingFilterQuery('');
                setPendingFilterId('');
            } else {
                if (pageGroup === pageGroupType.ALL_CUSTOMERS) {
                    setPendingFilterList(matchFilter[0].customerFiltersList);
                } else {
                    setPendingFilterList(matchFilter[0].filterList);
                }
                setPendingFilterId(matchFilter[0].id);
                setPendingFilterQuery(matchFilter[0].filterQuery);
            }
            setNoEmptyRows(true);
        }
        if (selectedCustomerFilterList !== newValue) {
            setSelectedCustomerFilterList(newValue);
            if (newValue === 'create_custom') {
                setPendingFilterName(pendingCreateCustomFilterName);
            } else if (newValue === 'redReport') {
                setPendingFilterName('Red Report');
            } else {
                setPendingFilterName(newValue);
            }
            setErrorMsg('');
        }
    };

    const theme = useTheme();

    return (
        <ThemeProvider theme={{ ...theme, mobile }}>
            <div css={customerStatFilterByCustomerIdDivCSS}>
                <table css={customStatFilterRadioCSS}>
                    <thead css={statFilterTableHeadingCSS}>
                        <tr>
                            <th>Saved Filters</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            onClick={() => handleSetSelectedCustomerList('create_custom')}
                            css={
                                selectedCustomerFilterList === 'create_custom'
                                    ? selectedRadioCSS
                                    : customerStatFilterRadioCSS
                            }
                        >
                            <td>
                                <Radio
                                    value="create_custom"
                                    checked={selectedCustomerFilterList === 'create_custom'}
                                    css={customerStatFilterRadioCSS}
                                    onChange={() => handleSetSelectedCustomerList('create_custom')}
                                />
                            </td>
                            <td>Create Custom Filter</td>
                            <td />
                        </tr>

                        {showPlatformOnlyFilters ? (
                            <tr
                                onClick={() => handleSetSelectedCustomerList('redReport')}
                                css={
                                    selectedCustomerFilterList === 'redReport'
                                        ? selectedRadioCSS
                                        : customerStatFilterRadioCSS
                                }
                            >
                                <td>
                                    <Radio
                                        value="redReport"
                                        checked={selectedCustomerFilterList === 'redReport'}
                                        css={customerStatFilterRadioCSS}
                                        onChange={() => handleSetSelectedCustomerList('redReport')}
                                    />
                                </td>
                                <td>Red Report</td>
                                <td />
                            </tr>
                        ) : null}
                        <CustomCustomerStatFilter
                            userPreferenceFilters={userPreferenceFilters}
                            setUserPreferenceFilters={setUserPreferenceFilters}
                            setPendingFilterList={setPendingFilterList}
                            setPendingFilterQuery={setPendingFilterQuery}
                            setPendingFilterId={setPendingFilterId}
                            selectedCustomerFilterList={selectedCustomerFilterList}
                            handleSetSelectedCustomerList={handleSetSelectedCustomerList}
                            pendingFilterId={pendingFilterId}
                            pendingFilterQuery={pendingFilterQuery}
                            pendingFilterList={pendingFilterList}
                            mobile={mobile}
                            familyId={familyId}
                            pageGroup={pageGroup}
                            setErrorMsg={setErrorMsg}
                        />
                    </tbody>
                </table>
            </div>
        </ThemeProvider>
    );
}

CustomerStatFilterSavedFiltersSelection.propTypes = {
    allStats: PropTypes.arrayOf(
        PropTypes.shape({
            compoundKey: PropTypes.string,
            label: PropTypes.string,
            statKey: PropTypes.string,
            type: PropTypes.string,
        }),
    ),
    familyId: PropTypes.number,
    mobile: PropTypes.bool,
    showPlatformOnlyFilters: PropTypes.bool,
};
